import React from "react";
import {IconButton, TextField} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

interface TextFilterProps {
    label: string;
    value: string;
    setFilter: (value: string) => void;
    removeFilter: () => void;
    isMobile: boolean;
}

const TextFilter: React.FC<TextFilterProps> = ({label, value, setFilter, removeFilter, isMobile}) => (
    <TextField
        label={label}
        value={value}
        onChange={(e) => setFilter(e.target.value)}
        fullWidth={isMobile}
        variant="standard"
        margin="normal"
        InputProps={{
            endAdornment: value ? (
                <IconButton
                    onClick={removeFilter}
                    size="small"
                >
                    <ClearIcon/>
                </IconButton>
            ) : null,
        }}
        sx={{minWidth: 180}}
    />
);

export default TextFilter;